import React from 'react';
import { Loader2 } from 'lucide-react';
import './ButtonSpinner.css';

/**
 * Baustein 8c — Inline-Spinner.
 * Lucide Loader2 mit Rotations-Animation. Für Button-Aktionen / Form-Submits.
 */
export default function ButtonSpinner({ size = 16 }) {
  return <Loader2 size={size} className="button-spinner" aria-hidden />;
}
